module.exports = __webpack_public_path__ + "static/media/pi.d1d09489.svg";